import { ErrorBoundaryBase } from "../ErrorBoundaryBase";

export const LayoutErrorBoundary = ErrorBoundaryBase;
